(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/wager.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/wager.js');

'use strict';
var constants = svs.maltipset.constants;

svs.maltipset.models.Wager = Backbone.Model.extend({
  log: new svs.core.log.Logger('svs.maltipset.models.Wager'),
  wagerProps: {
    productId: 'MAL'
  },
  initialize: function(data, options) {
    this.coupon = options.coupon;
    var self = this;
    var totalCost = this.coupon.get('totalCost');
    var sportkryssBet = this.coupon.get('sportkryssBet');
    var totalBetCost = this.coupon.get('hasSportkryssBet') ?
      totalCost - sportkryssBet.rowPriceMulti * 10 * this.coupon.get('numWeeks') :
      totalCost;

    this.wagerProps.extradata = { rounds: this.coupon.get('numWeeks') };

    if (!data.bets) {
      var betObject = {
        productId: 'MAL',
        drawNum: this.coupon.get('draw').get('drawNumber'),
        numDraws: options.numWeeks || 1,
        betAmountSalesGroup1: svs.utils.format.CurrencyAsJupiterString(
          totalBetCost
        ),
        betAmountSalesGroup2: '0,00',
        rowPriceMulti: 1,
        betProperties: []
      };

      if (this.coupon.get('isProlonging')) {
        betObject.betProperties.push(
          svs.maltipset.constants.BET_PROPERTIES.PROLONGATION
        );
      }

      betObject.numberBoards = this.getBetRows();
      this.get('bets').push(betObject);
    } else {
      _.each(this.get('bets'), function(bet) {
        bet.numDraws = options.numWeeks || 1;
        if (bet.productId === 'MAL') {
          bet.betAmountSalesGroup1 = svs.utils.format.CurrencyAsJupiterString(
            totalBetCost
          );
        } else {
          bet.betAmountSalesGroup1 = svs.utils.format.CurrencyAsJupiterString(
            bet.rowPriceMulti * 10 * self.coupon.get('numWeeks')
          );
        }
      });
    }

    this.wagerProps.message = svs.components.sport.getPaymentConfirmMessage({
      productName: constants.PRODUCT_NAME,
      amount: totalCost
    });

    this.set(
      'totalCostFormatted',
      svs.utils.format.Currency(totalCost, false)
    );
  },
  getBetRows: function() {
    var boards = [],
      self = this,
      boardData = this.coupon.getBoardData();

    _.each(boardData, function(board) {
      var bet = {
        systemType: [self.getSystemName()],
        systemNum:
          self.coupon.get('system') ===
          svs.maltipset.constants.SYSTEM.NO_SYSTEM
            ? 0
            : board.length,
        numSelections: board.length,
        participation: '0',
        rowPriceMulti: 1,
        boardData: board,
        boardProps: self.getBoardProps()
      };
      boards.push(bet);
    });

    return boards;
  },
  getBoardProps: function() {
    if (this.coupon.get('xpertSize') > 0) {
      return [this.coupon.get('xpertSystem')];
    }
    return [];
  },
  getSystemName: function() {
    switch (this.coupon.get('system')) {
      case svs.maltipset.constants.SYSTEM.NO_SYSTEM:
        return 'SROW';
      case svs.maltipset.constants.SYSTEM.M_SYSTEM:
        return 'MSYS';
      case svs.maltipset.constants.SYSTEM.R_SYSTEM:
        return 'RSYS';
      default:
    }
  },
  pay: function(success, error) {
    svs.lbUtils.wager.pay(this.toJSON(), this.wagerProps, success, error);
  },
  defaults: function() {
    return {
      crc: 0,
      marketInfo: 0,
      bagType: 0,
      bets: []
    };
  }
});


 })(window);